import http from '@http'

// 获取公告列表数据
export function getAnnouncementList(data) {
  return http.post('/server/message/list', data, { baseURL: '/newApi' })
}

// 发布系统公告
export function publishAnnouncement(data) {
  return http.post('/server/message/publish', data, { baseURL: '/newApi' })
}

// 修改本项目发布的公告
export function updateAnnouncement(data) {
  return http.put(`/server/message/${data.messageId}`, data, { baseURL: '/newApi' })
}

// 删除本项目发布的公告
export function deleteAnnouncement(messageId) {
  return http.delete(`/server/message/${messageId}`, {}, { baseURL: '/newApi' })
}

// 获取系统列表
export function getSystemList() {
  return http.get('/server/system/list', {}, { baseURL: '/newApi' })
}

// 上传图片
export function uploadImage(data) {
  return http.post('/file/upload', data, { baseURL: '/newApi' })
}
